import { createSelector } from '@reduxjs/toolkit';

import { isModelConceptClass } from 'src/containers/ProjectDiagram/utils/data';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectNodeDataArraySelector } from 'src/selectors/projectNodeDataArray';

export const projectClassIrisSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(projectNodeDataArraySelector(projectId), (nodeDataArray) =>
      nodeDataArray.reduce<Set<string>>((acc, nodeData) => {
        if (isModelConceptClass(nodeData)) {
          acc.add(nodeData.value);
        }
        return acc;
      }, new Set())
    )
);
